import { render, staticRenderFns } from "./AutoLogout.vue?vue&type=template&id=634883c8&"
import script from "./AutoLogout.vue?vue&type=script&lang=js&"
export * from "./AutoLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports